<template>
	<section v-if="section && section.type == 'home'" :class="['container section', section.type]">
		<div class="row">
			<highlight-news-component></highlight-news-component>
		</div>
		<div class="row">
			<next-matches-component></next-matches-component>
		</div>

		<div class="home__component-group gsap-fade-up">
			<div class="row">
				<div class="col col-lg-8">
					<div class="row" v-if="firstLeague">
						<div class="col">
							<router-link
								:to="{name: 'page', params: {sectionSlug: teamsSlug.slug, subsectionSlug: actifs.slug, pageSlug: firstLeague.slug}}"
								class="component__info-panel">
								<div class="bg" v-if="firstLeague.image" :style="{backgroundImage: 'url('+normal(firstLeague.image)+')'}"></div>
								<div class="content">
									<span class="date">Équipes</span>
									<h1 class="title">{{firstLeague.name}}</h1>
									<span class="view-more">Voir l’équipe</span>
								</div>
							</router-link>
						</div>
					</div>

					<div class="row" v-if="homeMerch">
						<div class="col">
							<router-link
								:to="{name: 'SubSection', params: {sectionSlug: 'merchandising', subsectionSlug: 'produits'}}"
								class="component__info-panel">
								<div class="bg" :style="{backgroundImage: homeMerch.fields.gallery.value ? 'url('+medium(homeMerch.fields.gallery.value[0])+')' : ''}"></div>
								<div class="content">
									<span class="date">Équipements</span>
									<h1 class="title">{{homeMerch.title}}</h1>
									<span class="view-more">En savoir plus</span>
								</div>
							</router-link>
						</div>
					</div>

				</div>
				<div class="col-lg-4">
					<div class="iframe-container">
						<iframe class="sfvFullHeight home-iframe" frameborder="0" scrolling="no" src="https://widget.football.ch/fr/Widgets.aspx/v-1047707/t-59439/a-tra/"></iframe>
					</div>
					<!-- <calendar-component></calendar-component>	 -->
				</div>
			</div>
		</div>
	</section>
</template>

<script>
	import _find from 'lodash/find'
	import _isUndefined from 'lodash/isUndefined'
	import { mapState } from 'vuex'
  import TweenMax from "gsap/TweenMax"

	// Components
	import HighlightNews from './component-parts/highlight-news-component'
	import NextMatches from './component-parts/next-matches-component'
	import Calendar from './component-parts/ranking-calendar-component'

	export default {
		name: 'SectionComponent',
		components: {
			'highlight-news-component': HighlightNews,
			'next-matches-component': NextMatches,
			'calendar-component': Calendar
		},
		created: function () {
			this.fetchData()
		},
		watch: {
			$route: function () {
				this.fetchData()
			}
		},
		data () {
			return {
				section: {},
				sections: [],
				user: {
					last_name: '',
					first_name: '',
					address: '',
					email: ''
				},
				params: {
					title: '',
					description: '',
					descriptionTwitter: '',
					titleTwitter: '',
					descriptionFacebook: '',
					titleFacebook: '',
					image: '',
					imageTwitter: '',
					imageFacebook: '',
					linkCanonical: ''
				}
			}
		},
		computed: {
			homeMerch() {
				return this.section.collections[0].pages.filter( el => el.tags[0].name == 'merchandising' )[0]
			},
			teamsSlug() {
				return _find(this.sections, {type: 'teams'})
			},
			firstLeague() {
				return _find(this.teams, {slug: '1ere-equipe'})
			},
			actifs() {
				return _find(this.teamsWithCategories, {type: 'actifs'})
			},
			...mapState({
				teams: 'teams',
				allSections: 'allSections',
				teamsWithCategories: 'teamsWithCategories'
			})
		},
		head: {
			title: function () {
				return {
					inner: this.params.title,
					separator: ' '
				}
			},
			meta: function () {
				return [
					{ n: 'description', c: this.params.description},
					{ n: 'keywords', c: this.params.keywords},
					{ n: 'twitter:title', c: this.params.titleTwitter},
					{ n: 'twitter:description', c: this.params.descriptionTwitter},
					{ n: 'twitter:image', c: `${url}/uploads/${this.params.imageTwitter}`},
					{ p: 'og:title', c: this.params.titleFacebook },
					{ p: 'og:description', c: this.params.descriptionFacebook},
					{ p: 'og:image', c: `${url}/uploads/${this.params.imageFacebook}`},
					{ p: 'og:url', h: `${url}`}
				]
			},
			link: function() {
				return [
					{ r: 'canonical', h: this.params.linkCanonical}
				]
			}
		},
		methods: {
			fetchData () {
				const sections = this.$store.getters.getSections
				const section = _find(sections, {slug: this.$route.params.sectionSlug})
				this.section = section
				this.sections = sections

				this.params = this.formatMeta(this.section)
				this.$nextTick( () => {
					this.$emit('updateHead')
					this.fadeUp('.gsap-fade-up')
				})


				// Home Iframe set height
				let iframeIntervalHome = setInterval(() => {
					checkHeight()
				}, 1000)

				function checkHeight() {
					var myFrames = null;
					myFrames = document.querySelector('.home-iframe');
					if (myFrames && myFrames.clientHeight > 300) {
						clearInterval(iframeIntervalHome)
					}

					if (myFrames && myFrames.className.indexOf('home-iframe') >= 0) {
						myFrames.contentWindow.postMessage('getHeight;' + myFrames.src, myFrames.src);
					}

					window.addEventListener('message', function(e) {
						if (!myFrames) {
							return;
						}
						var sourceFrame = null;
						if (e.data.toString().indexOf(myFrames.src) > 0) {
							sourceFrame = myFrames;
						}

						if (sourceFrame != null)
						{
							sourceFrame.style.height = e.data.toString().split(';')[0] + 'px';
						}
					}, false);
				}

				if (this.section.type !== 'home') {
					clearInterval(iframeIntervalHome)
				}
			},

			sendEmail: function (e) {

                axios.post('/api/v2/mail/send', this.user).then((response) => {
                    this.user = {}
                }, (err) => {
                    throw Error('Error form')
				})

            },

			// Animations
			fadeUp(el) {
				TweenMax.staggerFromTo(el, .7, {opacity: 0, y:30}, {opacity: 1, y:0}, 0.2)
			},
			fade(el) {
				TweenMax.staggerFromTo(el, 7, {opacity: 0}, {opacity: 1}, 0.2)
			}
		}
	}
</script>


